import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CalendarDays, Loader2 } from "lucide-react";

export function SlotPicker({ serviceId, value, onChange, days: range = 14 }) {
  const [days, setDays] = useState(null);
  const [day, setDay] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setDays(null); setDay(null); setError("");
    api.get("/availability", { params: { service_id: serviceId, days: range } })
      .then((r) => { setDays(r.data.days); setDay(r.data.days[0]?.date || null); })
      .catch(() => setError("Couldn't load open times — please refresh or call 310-422-0669."));
  }, [serviceId, range]);

  if (error) return <div className="text-sm text-amber-300" data-testid="slots-error">{error}</div>;
  if (!days) return <div className="flex items-center gap-2 text-slate-400 text-sm" data-testid="slots-loading"><Loader2 className="w-4 h-4 animate-spin" /> Checking David's calendar…</div>;
  if (!days.length) return <div className="text-sm text-slate-400" data-testid="slots-empty">No open times in the next two weeks — call 310-422-0669 and we'll fit you in.</div>;
  const current = days.find((d) => d.date === day) || days[0];

  return (
    <div data-testid="slots-container">
      <div className="dg-eyebrow mb-2 flex items-center gap-2"><CalendarDays className="w-3 h-3" /> Pick a day <span className="text-slate-500 normal-case tracking-normal font-sans">· times in Pacific</span></div>
      <div className="flex gap-2 overflow-x-auto dg-scroll pb-2">
        {days.map((d) => (
          <button key={d.date} type="button" onClick={() => { setDay(d.date); onChange(null); }} data-testid={`day-${d.date}`}
            className={`shrink-0 rounded-xl border px-3 py-2 text-sm transition-colors ${current.date === d.date ? "bg-cyan-500 text-slate-900 border-cyan-500" : "bg-slate-900/50 border-slate-800 text-slate-200 hover:border-cyan-400"}`}>
            <div className="font-semibold">{d.label}</div>
            <div className="text-[10px] font-mono uppercase tracking-widest opacity-70">{d.slots.length} open</div>
          </button>
        ))}
      </div>
      <div className="dg-eyebrow mt-4 mb-2">Pick a time</div>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
        {current.slots.map((s) => (
          <button key={s.start_at} type="button" onClick={() => onChange(s)} data-testid={`slot-${s.start_at}`}
            className={`rounded-lg border px-2 py-3 min-h-[44px] text-sm transition-colors ${value?.start_at === s.start_at ? "bg-cyan-500 text-slate-900 border-cyan-500" : "bg-slate-900/50 border-slate-800 text-slate-200 hover:border-cyan-400"}`}>
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
